import React from 'react';
import './App.css';
import EventSeries from './components/EventSeries';

function App() {
    return <EventSeries />;
}

export default App;
